// extracted by mini-css-extract-plugin
module.exports = {"textViewer":"textViewer_textViewer_1Q7wm"};